import React, { useEffect, useState } from 'react';
import BlazeInputDropdown, {
  BlazeDropdownItem,
} from '../../../../../../components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';

interface SelectOperatorDropdownProps {
  selectedOperator: string | null;
  onChangeOperator: (filterOperator: FilterOperator | null) => void;
}

//EQUALS, LESS_THAN, GREATER_THAN, STARTS_WITH, ENDS_WITH, IN_LIST
export enum FilterOperator {
  EQUALS = 'EQUALS',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN = 'GREATER_THAN',
  STARTS_WITH = 'STARTS_WITH',
  ENDS_WITH = 'ENDS_WITH',
  IN_LIST = 'IN_LIST',
}

const operators: BlazeDropdownItem[] = [
  {
    id: FilterOperator.EQUALS,
    name: 'Equals',
  },
  {
    id: FilterOperator.LESS_THAN,
    name: 'Less than',
  },
  {
    id: FilterOperator.GREATER_THAN,
    name: 'Greater than',
  },

  {
    id: FilterOperator.STARTS_WITH,
    name: 'Starts With',
  },
  {
    id: FilterOperator.ENDS_WITH,
    name: 'Ends with',
  },
  {
    id: FilterOperator.IN_LIST,
    name: 'In',
  },
];

const SelectOperatorDropdown = (props: SelectOperatorDropdownProps) => {
  const getSelectedOperator = (opValue: string | null) => {
    if (!opValue) {
      return null;
    }
    const operatorItem = operators.find(operator => operator.id === opValue);
    return operatorItem ? operatorItem : null;
  };

  const [selectedOperator, setSelectedOperator] = useState<BlazeDropdownItem | null>(
    getSelectedOperator(props.selectedOperator),
  );

  useEffect(() => {
    setSelectedOperator(getSelectedOperator(props.selectedOperator));
  }, [props.selectedOperator]);

  const onSelect = (item: BlazeDropdownItem) => {
    const fo: FilterOperator = FilterOperator[item.id];
    if (fo === undefined) {
      throw new Error('operator does not exists');
    }
    props.onChangeOperator(fo);
  };

  return (
    <BlazeInputDropdown
      id={'selectOperatorDropdown'}
      onClick={onSelect}
      selected={selectedOperator}
      items={operators}
    ></BlazeInputDropdown>
  );
};

export default SelectOperatorDropdown;
